<p-dialog
  [(visible)]="visible"
  [modal]="true"
  [dismissableMask]="false"
  (onHide)="visibleChange.emit(false)"
  class="reusable-modal"
  [draggable]="false"
>
  <ng-template pTemplate="header" class="header">
    <span>{{ header }}</span>
  </ng-template>
  <div class="content-wrapper">
    <ng-content></ng-content>
  </div>
  <ng-template pTemplate="footer">
    <div class="footer-buttons" [ngClass]="{ 'no-border': !showFooterBorder }">
      <button
        *ngIf="isInfoDialog"
        type="button"
        (click)="close()"
        class="p-button submit-button"
      >
        {{
          isInfoDialogButtonText
            ? isInfoDialogButtonText
            : CUSTOMER_ONBOARDING_CONSTANTS.DONE_BUTTON_LABEL
        }}
      </button>

      <ng-container *ngIf="!isInfoDialog">
        <button
          type="button"
          (click)="onCancel.emit(); close()"
          class="p-button cancel-button"
        >
          {{ cancelButtonText }}
        </button>
        <button
          type="button"
          (click)="onSubmit.emit()"
          class="p-button submit-button"
        >
          {{ submitButtonText }}
        </button>
      </ng-container>
    </div>
  </ng-template>
</p-dialog>
